import { Gutters, Typography } from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { FC, useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../i18n/i18next'
import { useEphemeralStore } from '../../state/useEphemeralStore'
import { NavigationView } from '../layout/NavigationView'
import { HotelAvailCard } from './hotelInfo/hotelAvailCard'

export const HotelAvailPage: FC = () => {
    const { hotelResp } = useEphemeralStore(
        useShallow((s) => ({
            hotelResp: s.hotelResp,
        }))
    )

    /// To scroll to top of page...
    useEffect(() => {
        setTimeout(() => {
            window.document
                .getElementById('roomTypesListHeader')
                .scrollIntoView(false)
        }, 100)
    }, [])

    if (!hotelResp) {
        return null
    }

    return (
        <NavigationView
            navigationBarTitle={i18n.t('booking.avail')}
            navigationBarSubtitle={hotelResp.hotelInfo.name}
            backButtonAction={() => {
                window.goBack()
            }}
        >
            <Box display={'grid'}>
                <Gutters>
                    <Box display={'grid'} maxWidth={'90vw'} gap={'8px'}>
                        <Typography variant="bodyBold" id="roomTypesListHeader">
                            {i18n.t('booking.roomTypes')}
                        </Typography>
                        {hotelResp.rates.rates.map((rate, index) => {
                            return (
                                <HotelAvailCard
                                    key={'availCard' + index}
                                    rate={rate}
                                />
                            )
                        })}
                        <Box height={'32px'} />
                    </Box>
                </Gutters>
            </Box>
        </NavigationView>
    )
}
